import React, { useState } from 'react';
import { Box, ButtonBase, SvgIcon, Typography, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/system';
import { SvgIconProps } from '@mui/material/SvgIcon'; // 1. この行を追加
import AdsClickIcon from '@mui/icons-material/AdsClick';

// 各セグメント（ボタン）のスタイル
const SegmentButton = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'color' && prop !== 'rotation',
})<{ color: string; rotation: number }>(({ theme, color, rotation }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: color,
  transformOrigin: '50% 50%',
  transform: `rotate(${rotation}deg)`,
  clipPath: 'polygon(50% 50%, 0% 0%, 100% 0%)',
  transition: 'background-color 0.3s ease, filter 0.3s ease',
  '&:hover': {
    filter: 'brightness(1.15)',
  },
  // 変更：.MuiIcon-rootも対象に含めるとより堅牢になります
  '& .MuiSvgIcon-root, & .MuiTypography-root, & .MuiIcon-root': {
    transform: `rotate(${-rotation}deg)`,
    color: 'white',
  },
  '& .MuiSvgIcon-root, & .MuiIcon-root': {
    marginBottom: theme.spacing(1),
  },
}));

// ドーナツの中央の穴
const CenterHole = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '40%',
  height: '40%',
  borderRadius: '50%',
  backgroundColor: 'white',
  pointerEvents: 'none',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 99,
}));


// --- Propsとメニューアイテムの型定義 ---

export interface MenuItem {
  id: string;
  label: string;
  color: string;
  // 2. iconの型をより具体的にする
  icon: React.ComponentType<SvgIconProps>;
}

interface DonutMenuProps {
  items: MenuItem[];
  onItemClick: (id: string) => void;
}

// --- コンポーネント本体 (変更なし) ---
export const DonutMenu: React.FC<DonutMenuProps> = ({ items, onItemClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  // ドーナツメニュー全体のラッパー
  const DonutWrapper = styled(Box)({
    position: 'relative',
    width: isMobile ? 150 : 300,
    height: isMobile ? 150 : 300,
    margin: '0',
    overflow: 'hidden',
    borderRadius: '50%',
  });
  const [activeSegment, setActiveSegment] = useState<string | null>(items.length > 0 ? items[0].id : null);
  const segmentCount = items.length;
  if (segmentCount === 0) {
    return null;
  }
  const anglePerSegment = 360 / segmentCount;

  return (
    <DonutWrapper>
      {items.map((item, index) => {
        const rotation = index * anglePerSegment - (anglePerSegment / 2);
        const IconComponent = item.icon;

        return (
          <SegmentButton
            key={item.id}
            color={item.color}
            rotation={rotation}
            onClick={() => {
              setActiveSegment(item.id);
              onItemClick(item.id);
            }}
            //　選択状態がわかるように
            sx={{
              ...(activeSegment === item.id && {
                display: 'none'
              }),
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                top: '10%',
                left: '50%',
                transform: 'translateX(-50%)',
              }}
            >
              {/* この部分のエラーが解消されます */}
              <IconComponent fontSize='large' />
              <Typography variant="caption">{item.label}</Typography>
            </Box>
          </SegmentButton>
        );
      })}
      <CenterHole >
        <AdsClickIcon fontSize='large' />
      </CenterHole>
    </DonutWrapper>
  );
};

export default DonutMenu;